import { Component, Input } from '@angular/core';
import { EntitiesFacade } from 'src/app/abstraction/entities.facade';
import { Patient } from 'src/app/shared/models/patient';
import { Provider } from 'src/app/shared/models/provider';

@Component({
    selector: 'app-patient-provider-cell',
    templateUrl: './patient-provider-cell.component.html',
    styleUrl: './patient-provider-cell.component.scss',
})
export class PatientProviderCellComponent {
    @Input() patient: Provider | Patient | null | undefined;
    @Input() compact = false;

    constructor(private readonly entitiesFacade: EntitiesFacade) {}

    get label(): string {
        return this.entitiesFacade.getProvidersFullName(this.patient as Provider) || '';
    }
}
